import * as React from 'react';
import { Body2 } from '@cian/ui-kit';

import { ITextCell } from '../../../../../../types/newbuildingsCompare';

export interface ITextCellProps {
  cell: ITextCell;
}

export const TextCell = ({ cell }: ITextCellProps): React.JSX.Element => (
  <Body2>{cell.data?.text ?? cell.state.text ?? ''}</Body2>
);
